export default [
  {
    path: '/package/bigo',
    name: 'list-bigo-package',
    component: () => import('@/views/bigo/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      resource: 'bigo',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/bigo/create',
    name: 'create-bigo-package',
    component: () => import('@/views/bigo/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-bigo-package',
      resource: 'bigo',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-bigo-package' },
        },
        {
          text: 'breadcrumb.createPackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/bigo/:id/update',
    name: 'update-bigo-package',
    component: () => import('@/views/bigo/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-bigo-package',
      resource: 'bigo',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-bigo-package' },
        },
        {
          text: 'breadcrumb.updatePackage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/package/bigo/:id',
    name: 'view-bigo-package',
    component: () => import('@/views/bigo/View.vue'),
    meta: {
      pageTitle: 'breadcrumb.package',
      navActiveLink: 'list-bigo-package',
      resource: 'bigo',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listPackage',
          to: { name: 'list-bigo-package' },
        },
        {
          text: 'breadcrumb.viewPackage',
          active: true,
        },
      ],
    },
  },
]
